import styled from 'styled-components'

export const Svg = styled.svg`
  fill: ${({ fill }) => fill};
  height: ${({ height }) => height};
  width: ${({ width }) => width};

  &:hover {
    fill: ${({ fillOver }) => fillOver ? fillOver : 'unset'};
    transition: 200ms ease-in;
  }

  @media screen and (max-width: 768px) {
    width: ${({ width }) => width };
  }
`